import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Paginator } from 'src/app/shared/models/grid.model';
import { ImportNewFileRow, Literals } from '../models/literals.model';

export const ChangeIgnoreCustomLiterals = createAction(
  '[Import Export Literals]]: Change Ignore Custom Literals',
  props<{ ignoreCustom: boolean }>(),
);

export const ChangeIsForImport = createAction(
  '[Import Export Literals]]: Change Is For Import',
  props<{ isForImport: boolean }>(),
);

export const ExportLiterals = createAction('[Literals: Search]: Export Literals');

export const ExportLiteralsSuccess = createAction(
  '[Literals: Search]: Export Literals Success',
  props<{ res: HttpResponse<any> }>(),
);

export const ExportLiteralsFailed = createAction(
  '[Literals: Search]: Export Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ExportFileName = createAction(
  '[Import Export Literals]: Export File Name',
  props<{ exportFileName: string }>(),
);

export const DropZoneEnabled = createAction('[Import Export Literals]: Drop Zone Enabled');

export const DropZoneDisabled = createAction('[Import Export Literals]: Drop Zone Disabled');

export const ButtonPointerEventEnabled = createAction('[Import Export Literals]: Button Pointer Event Enabled');

export const ButtonPointerEventDisabled = createAction('[Import Export Literals]: Button Pointer Event Disabled');

export const GetFile = createAction('[Import Export Literals]: Get File', props<{ file: any }>());

export const RemoveFile = createAction('[Import Export Literals]: Remove File');

export const FileNameChanged = createAction(
  '[Import Export Literals]: File Name Changed',
  props<{ fileName: string }>(),
);

export const UploadedFileChanged = createAction(
  '[Import Export Literals]: Uploaded File Changed',
  props<{ name: string; size: number }>(),
);

export const FileToUploadChanged = createAction(
  '[Import Export Literals]: File To Upload Changed',
  props<{ fileToUpload: any }>(),
);

export const FileReaderError = createAction('[Import Export Literals]: File Reader Error');

export const ValidateLiterals = createAction('[Import Export Literals]: Validate Literals');

export const ValidateLiteralsSuccess = createAction(
  '[Import Export Literals]: Validate Literals Success',
  props<{ res: any }>(),
);

export const ValidateLiteralsFailed = createAction(
  '[Import Export Literals]: Validate Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ImportNewFileData = createAction(
  '[Import Export Literals]: Import New File Data',
  props<{ newFileData: ImportNewFileRow[] }>(),
);

export const ImportNewLiterals = createAction('[Import Export Literals]: Import New Literals');

export const ImportNewLiteralsSuccess = createAction(
  '[Import Export Literals]: Import New Literals Success',
  props<{ res: any }>(),
);

export const ImportNewLiteralsFailed = createAction(
  '[Import Export Literals]: Import New Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ClearImportNewLiterals = createAction('[Import Export Literals]: Clear Import New Literals');

export const ChangeSelectOnlyNewStatus = createAction(
  '[Import Export Literals]: Change Select Only New Status',
  props<{ selectOnlyNewStatus: boolean }>(),
);

export const LocaleGridSuccess = createAction('[Import Export Literals]: Locale Grid Success', props<{ res: any }>());

export const NewLiteralsPerPageChanged = createAction(
  '[Import Export Literals]: New Literals Per Page Changed',
  props<{ itemsNumber: number }>(),
);

export const NewLiteralsPagingChanged = createAction(
  '[Import Export Literals]: New Literals Paging Changed',
  props<{ paginator: Paginator }>(),
);

export const NewLiteralsData = createAction(
  '[Import Export Literals]: New Literals Data',
  props<{ newLiteralsData: any }>(),
);

export const GetImportExportLiteralsSuccess = createAction(
  '[Import Export Literals]: Get Import Export Literals Success',
  props<{ res: Literals[] }>(),
);

export const ChangeCheckedStatus = createAction(
  '[Import Export Literals]: Change Checked Status',
  props<{ isSelected: boolean; id: string }>(),
);
